m = require 'mithril'

ControlBlock = {
	view: (ctrl, args) ->
		m '.controlblock', args.content
}

module.exports = ControlBlock